
import {
    LOAD_AMPHURES_SUCCESS,
    SELECT_PROVINCE,
    RESET_PROVINCE,
  } from '../actions/types'

import amphuresFile from '../amphures.json'

const initialState = {
  amphuresFile,
  currentAmphur: [],
}

const amphures = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_AMPHURES_SUCCESS:
      return {
        ...state,
        ...action.payload,
      }
    case SELECT_PROVINCE:
      return {
        ...state,
        currentAmphur: action.data,
      }
    case RESET_PROVINCE:
      return {
        ...state,
        state: initialState,
      }
    default:
      return state
  }
}

export default amphures



// WEBPACK FOOTER //
// ./src/reducers/amphures.js